import type { ApiRoute, NoBody, NoQueryParams } from "../api"
import type { FinancingFormView } from "../vehicleDetails/overview/financing/FinancingFormView"

export interface GetFinancingFormViewPathParams {
	inventoryId: string
}

export const getFinancingFormViewRoute: ApiRoute<
	GetFinancingFormViewPathParams,
	NoQueryParams,
	NoBody,
	FinancingFormView
> = {
	buildUrl: (params) => `/vehicles/${params.inventoryId}/financing-form`,
	method: "get",
	path: "/vehicles/:inventoryId/financing-form",
}
